import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';
import { useContext } from 'react';
import { ProLayoutContext } from '../../../context/ProLayoutContext';

var genProLayoutBaseMenuStyle = function genProLayoutBaseMenuStyle(token) {
  var _collapsed, _collapsed2, _$concat2, _$concat4;

  return _defineProperty({}, "".concat(token.componentCls), (_$concat4 = {
    background: 'transparent',
    border: 'none'
  }, _defineProperty(_$concat4, "& &-collapsed", (_collapsed = {}, _defineProperty(_collapsed, "".concat(token.antCls, "-menu-item, \n        ").concat(token.antCls, "-menu-item-group > ").concat(token.antCls, "-menu-item-group-list > ").concat(token.antCls, "-menu-item, \n        ").concat(token.antCls, "-menu-item-group > ").concat(token.antCls, "-menu-item-group-list > ").concat(token.antCls, "-menu-submenu > ").concat(token.antCls, "-menu-submenu-title, \n        ").concat(token.antCls, "-menu-submenu > ").concat(token.antCls, "-menu-submenu-title"), {
    paddingInline: '0 !important',
    height: 'auto !important',
    marginBlock: '8px !important'
  }), _defineProperty(_collapsed, "".concat(token.antCls, "-menu-item-group > ").concat(token.antCls, "-menu-item-group-list > ").concat(token.antCls, "-menu-submenu-selected > ").concat(token.antCls, "-menu-submenu-title, \n        ").concat(token.antCls, "-menu-submenu-selected > ").concat(token.antCls, "-menu-submenu-title"), {
    backgroundColor: token.colorBgMenuItemSelected,
    borderRadius: token.radiusBase
  }), _defineProperty(_collapsed, "".concat(token.componentCls, "-group"), _defineProperty({}, "".concat(token.antCls, "-menu-item-group-title"), {
    paddingInline: 0
  })), _collapsed)), _defineProperty(_$concat4, '& &-item-title', _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&-collapsed': (_collapsed2 = {
      flexDirection: 'column',
      justifyContent: 'center'
    }, _defineProperty(_collapsed2, "".concat(token.componentCls, "-item-text"), {
      maxWidth: '100%'
    }), _defineProperty(_collapsed2, "".concat(token.componentCls, "-item-text-has-icon"), {
      display: 'none !important'
    }), _collapsed2)
  }, "&".concat(token.componentCls, "-item-collapsed-show-title"), _defineProperty({
    lineHeight: '16px',
    height: '48px'
  }, "&".concat(token.componentCls, "-item-title-collapsed"), (_$concat2 = {
    display: 'flex'
  }, _defineProperty(_$concat2, "".concat(token.componentCls, "-item-icon"), {
    height: '16px',
    lineHeight: '16px !important',
    '.anticon': {
      lineHeight: '16px',
      height: '16px'
    }
  }), _defineProperty(_$concat2, "".concat(token.componentCls, "-item-text"), {
    opacity: '1 !important',
    display: 'inline !important',
    textAlign: 'center',
    fontSize: 12,
    height: 12,
    lineHeight: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    margin: 0,
    padding: 0,
    marginBlockStart: 4
  }), _$concat2)))), _defineProperty(_$concat4, '&-group', _defineProperty({}, "".concat(token.antCls, "-menu-item-group-title"), {
    fontSize: 12,
    color: token.colorTextLabel,
    '.anticon': {
      marginInlineEnd: 8
    }
  })), _defineProperty(_$concat4, '&-group-divider', {
    color: token.colorTextSecondary,
    fontSize: 12,
    lineHeight: 20
  }), _$concat4));
};

export function useStyle(prefixCls) {
  var _useContext = useContext(ProLayoutContext),
      sider = _useContext.sider;

  return useAntdStyle('pro-layout-base-menu', function (token) {
    var proLayoutMenuToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    }, sider);

    return [genProLayoutBaseMenuStyle(proLayoutMenuToken)];
  });
}